import { CancelFunc, emptyCancel } from 'lib/cancel'
import { GetReturn } from 'lib/rpc'
import { unaryInvoke } from 'lib/rpcts'
import { IntrospectRequest, IntrospectResponse } from 'pbts/c1/api/auth/v1/auth'
import { AuthClient } from 'pbts/c1/api/auth/v1/auth.client'
import { Dispatch } from 'react'

export enum AuthAction {
    introspect,
}

export type IntrospectAction = {
    type: AuthAction.introspect
    payload: GetReturn<IntrospectResponse>
}

export type AuthActions = IntrospectAction

export const introspect = (dispatch: Dispatch<AuthActions>, client: AuthClient | undefined): CancelFunc => {
    if (!client) {
        return emptyCancel
    }

    const req = IntrospectRequest.create({})

    return unaryInvoke<IntrospectRequest, IntrospectResponse>(req, client.introspect.bind(client), (payload) => {
        dispatch({
            type: AuthAction.introspect,
            payload,
        })
    })
}
